import React from 'react'
import { Link } from "react-router-dom";


const BusinessPartnership = () => {
    return (
        <>
            <section className="page_breadcrumb" style={{ background: 'url(assets/img/breadcrumb_bg.webp)' }}>
                <div className="breadcrumb_overlay">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="breadcrumb_text">
                                    <h1>Business Partnership & Strategic Tie-up Opportunities</h1>
                                    <ul className="d-flex flex-wrap">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="/">Business Partnership & Strategic Tie-up Opportunities</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="services_details pt_120 xs_pt_100" style={{ marginTop: "-80px" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                            <div className="services_details_img">
                                <img src="assets/img/Health Products_01.webp" alt="service" className="img-fluid w-100" />
                            </div>
                            <div className="services_details_area">
                                <h2 className="details_title">Business Partnership & Strategic Tie-up Opportunities</h2>

                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabIndex={0}>
                                        <div className="service_details_overview">
                                            <p style={{ textAlign: "justify" }}>Sewax Services Private Limited believes that strong partnerships create stronger businesses. We welcome strategic alliances with companies, entrepreneurs, consultants, distributors, service providers, and industry professionals who share our vision of delivering quality, innovation, and customer satisfaction.</p>
                                            <p style={{ textAlign: "justify" }}>Whether you're looking to expand your services, enter new markets, or build long-term business relationships, Sewax Services Private Limited offers the expertise, network, and support to help you achieve sustainable growth. Together, we can create valuable opportunities, strengthen market presence, and deliver exceptional solutions to customers across diverse industries.</p>
                                            <h3>Services Include:</h3>
                                            <ul>
                                                <li> Business Owners & Entrepreneurs</li>
                                                <li> Corporate Organizations</li>
                                                <li>Government & Private Institutions</li>
                                                <li>  Builders & Real Estate Developers </li>
                                                <li> Facility Management Companies</li>
                                                <li> Contractors & Service Providers</li>
                                                <li>Chartered Accountants & Tax Consultants </li>
                                                <li>IT Companies & Digital Agencies</li>
                                                <li> Solar Energy Companies</li>
                                                <li> Import & Export Businesses</li>
                                                <li>Event Organizers </li>
                                                <li> HR & Recruitment Agencies</li>
                                                <li> Dealers, Distributors & Channel Partners</li>
                                                <li> Healthcare & Wellness Businesses</li>
                                                <li> Startups & MSMEs</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="blog_page pt_95 xs_pt_75" style={{marginTop:"-90px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="row">
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Financial Planning.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Investment Advisory.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Tax Planning.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Retirement Planning.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

        </>
    )
}

export default BusinessPartnership
